import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#27272a] bg-[#0a0a0a] mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2.5 h-2.5 bg-[#FF3B30]" />
              <span className="font-display text-lg">SourceDeck</span>
            </div>
            <p className="text-xs text-zinc-500 leading-relaxed max-w-[220px]">
              The creator workspace for solo YouTubers, podcasters, and independent studios.
            </p>
          </div>

          <div>
            <div className="sd-label mb-3">PRODUCT</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-pricing">Pricing</Link></li>
              <li><Link to="/dashboard" className="text-zinc-400 hover:text-white transition-colors">Dashboard</Link></li>
              <li><Link to="/marketplace" className="text-zinc-400 hover:text-white transition-colors">Sponsor Marketplace</Link></li>
            </ul>
          </div>

          <div>
            <div className="sd-label mb-3">LEGAL</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
              <li><Link to="/refund" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-refund">Refund Policy</Link></li>
            </ul>
          </div>

          <div>
            <div className="sd-label mb-3">SUPPORT</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-contact">Contact us</Link></li>
              <li><a href="mailto:hello@sourcedeck.tech" className="text-zinc-400 hover:text-white transition-colors">hello@sourcedeck.tech</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#27272a] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-mono text-[10px] text-zinc-600 uppercase tracking-wider">
            © {new Date().getFullYear()} SourceDeck · Made in India · Payments powered by Razorpay
          </div>
          <div className="font-mono text-[10px] text-zinc-600 flex gap-4">
            <Link to="/terms" className="hover:text-zinc-400">TERMS</Link>
            <Link to="/privacy" className="hover:text-zinc-400">PRIVACY</Link>
            <Link to="/refund" className="hover:text-zinc-400">REFUND</Link>
            <Link to="/contact" className="hover:text-zinc-400">CONTACT</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
